/** Claves de escena compartidas, para no repetir strings sueltos. */
export const SceneKeys = {
  Boot: 'Boot',
  Preload: 'Preload',
  Lobby: 'Lobby',
  Game: 'Game',
  Results: 'Results',
} as const;

export type SceneKey = (typeof SceneKeys)[keyof typeof SceneKeys];
